// extracted by mini-css-extract-plugin
export var hidden = "_tx-0";